module.exports = require("@dtvgo/typed-normalizr");